import { PermissionId } from '@e2m-customer-portal/shared';
import { AssignedPermissionInput } from '../generated/graphql';

export function isGranted(permissions: readonly AssignedPermissionInput[]): (permissionId: PermissionId) => boolean;

export function isGranted(permissions: readonly AssignedPermissionInput[], permissionId: PermissionId): boolean;

export function isGranted(
  permissions: readonly AssignedPermissionInput[],
  permissionId?: PermissionId,
): ((permissionId: PermissionId) => boolean) | boolean {
  const select = (id: PermissionId) =>
    permissions.some((permission) => permission.permissionId === id && permission.granted);
  if (permissionId == null) {
    return select;
  } else {
    return select(permissionId);
  }
}
